import { createFileRoute } from "@tanstack/react-router";
import { EquipmentCatalogPage } from "@/components/equipment/EquipmentCatalogPage";

export const Route = createFileRoute("/(protected)/_layout/equipment")({
  component: EquipmentCatalogPage,
});